module.exports = __webpack_public_path__ + "fonts/SFUIText-RegularItalic.927c53d1.eot";